<template>
  <div class="bot-performance-widget">
    <div class="header-widget">
      <p>Fallback Rate</p>
    </div>
    <NoResultsFound  v-if="botPerformanceData.fallbackMessage.length <= 0 || botPerformanceData.fallbackMessageCount <= 0 || botFallbackRate <= 0" class="no-result-content"/>
    <div v-else class="content-widget">
        <div class="fallback-rate">{{botPerformanceData.fallbackRate}}%</div>
        <p class="fallback-rate-subtitle">calculated from {{botPerformanceData.fallbackMessageCount | number}} messages</p>
        <p class="fallback-rate-subtitle">(excluded postback)</p>
        <div class="chart-content">
          <GChart
          id="bot-performance-chart"
          class="g-chart"
          type="PieChart"
          :data="botPerformanceChartData"
          :options="chartOptions"
          :events="chartEvents"
          ></GChart>
        </div>
        <div>
          <p class="text-center">A high fallback rate means</p>
          <p class="text-center">your bot needs more training or tuning</p>
          <!--        <p class="text-center tuning-bot-text">Tuning your bot</p>-->
          <router-link to="/understanding" class="nav-link" style="padding: unset;" exact>
            <p class="text-center tuning-bot-text">Tuning your bot</p>
          </router-link>
        </div>
        <!-- <div class="float-unit" v-if="botFallbackMessage && botFallbackMessage.length > 0">
          <div class="float-unit-content">
            <span>0</span>
            <span>100</span>
          </div>
        </div> -->
      <!-- <div class="result-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>Common fallback messages</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="message in botFallbackMessage" :key="message.message">
              <td class="message-text">{{message.message}}</td>
              <td>
                <span class="message-value">{{message.count}}</span>
                <span class="message-percent">({{message.portion}}%)</span>
              </td>
            </tr>
            <tr v-if="!botFallbackMessage || botFallbackMessage.length === 0">
              <td class="text-center no-data-text" colspan="2">
                Empty fallback message data ...
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="bottom-foot">Check Benchmark</div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { GChart } from 'vue-google-charts';
import NoResultsFound from '../NoResultsFound.vue';

export default {
  name: 'bot-performance-widget',
  components: {
    GChart,
    NoResultsFound
  },
  props: {
    criteria: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chartOptions: {
        // height: 120,
        chartArea: {
          top: 30,
        },
        colors: ['#44BC37', '#ddd'],
        legend: 'none',
        pieHole: 0.6,
        pieStartAngle: 270,
        pieSliceText: 'none',
        title: 'Fallback Rate',
        tooltip: {
          text: 'value',
        },
        slices: {
          2: {
            color: 'transparent',
          },
        },
        theme: 'maximized',
      },
      chartEvents: {
        ready: () => {
          // set width of label 0 - 100
          try {
            const chartWidth = document
              .querySelector('#bot-performance-chart g')
              .getBoundingClientRect().width;
            // console.log(chartWidth);
            document.querySelector('.float-unit-content').style.width = `${chartWidth}px`;
          } catch (e) {
            // console.log('Cannot get chart width');
          }
          if (document.querySelector('#bot-performance-chart text')) {
            if (document.querySelector('#bot-performance-chart text').innerHTML === 'No data') {
              document.querySelector('#bot-performance-chart text').style.opacity = '0.5';
            }
          }
        },
      },
    };
  },
  watch: {
    criteria: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      loadBotPerformance: 'dashboard/loadBotPerformance',
    }),
    async init() {
      await this.loadBotPerformance({
        criteria: this.criteria,
      });
    },
  },
  computed: {
    ...mapGetters({
      botPerformanceData: 'dashboard/botPerformanceData',
    }),
    botPerformanceChartData() {
      const finalData = [['Name', 'Value']];
      if (this.botPerformanceData) {
        const { fallbackRate } = this.botPerformanceData;
        if (fallbackRate) {
          finalData.push(['Fallback Rate', { v: fallbackRate, f: `${fallbackRate}%` }]);
          const inverseValue = 100 - fallbackRate;
          finalData.push(['Accepted', { v: inverseValue, f: `${inverseValue}%` }]);
          finalData.push([null, 100]);
        }
      } else {
        finalData.push([null, 0]);
      }
      return finalData;
    },
    botFallbackMessage() {
      let result = [];
      if (this.botPerformanceData) {
        const { fallbackMessage } = this.botPerformanceData;
        if (fallbackMessage) {
          result = fallbackMessage;
        }
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.bot-performance-widget {
    display: flex;
    flex-direction: column;
    height: 100%;
    .header-widget{
      padding: 16px 16px 12px 16px;
      border-bottom: 1px solid #E9EBEC;
      font-size: 16px;
      font-weight: 500;
      line-height: 19.2px;
      color: #111B49;
      display: flex;
      justify-content: space-between;
      p {
          margin-bottom: 0px
      }
    }
    .no-result-content{
      margin-top: 97px;
      margin-bottom: 97px;
    }
    .chart-content{
      overflow: hidden;
      height: 130px;
      width: 270px;
      margin-bottom: 30px;
    }
    .content-widget{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 31px;
      .fallback-rate{
        font-size: 26px;
        line-height: 31.2px;
        color: #0D173C;
      }
      .fallback-rate-subtitle{
        font-size: 13px;
        font-weight: 400;
        line-height: 19.5px;
        color: #646A8C;
        margin-bottom: 0;
      }
      .tuning-bot-text{
        margin-top: 18px;
        margin-bottom: 0px;
        color: #3371FF;
      }
    }
  .card-body {
    padding: 0;
  }
  .chart-container {
    overflow: hidden;
    height: 130px;
    position: relative;
    .float-unit {
      position: absolute;
      width: 100%;
      bottom: 25px;
      font-size: 0.7rem;
      z-index: 10;
      color: #b9b9b9;
      display: flex;
      justify-content: center;
      .float-unit-content {
        padding-left: 8px;
        display: flex;
        justify-content: space-between;
      }
    }
    .float-value {
      position: absolute;
      bottom: 40px;
      font-size: 1.1rem;
      width: 100%;
      text-align: center;
      color: #666;
    }
  }
  .result-wrapper {
    max-height: 240px;
    min-height: 240px;
    overflow-y: auto;
    .table {
      th {
        position: sticky;
        top: -1px;
        right: -1px;
        background-color: #ed5454;
        border-bottom: none;
        font-size: 0.7rem;
        color: #fff;
      }
    }
  }
  .message-text {
    font-weight: 500;
    color: #555;
  }
  .message-value {
    color: #666;
    margin-right: 5px;
  }
  .message-percent {
    color: #aaaaaa;
    font-size: 0.65rem;
  }
  .bottom-foot {
    cursor: pointer;
    padding: 8px;
    font-size: 0.7rem;
    text-align: center;
    color: #888;
    border-top: 1px solid #ddd;
    background-color: #eee;
    &:hover {
      font-weight: 400;
    }
  }
  .no-data-text {
    font-size: 12px;
    color: #aaa;
    line-height: 42px;
  }
}
</style>
